import { useAuth } from '../contexts/AuthContext'
import HeaderGuest from './HeaderGuest'
import HeaderAuthenticated from './HeaderAuthenticated'

export default function Header() {
  const { isAuthenticated, loading } = useAuth()

  // Đợi loading xong mới render header để tránh flash
  if (loading) {
    // Render header guest tạm thời khi đang loading
    // Hoặc có thể render một loading state
    return <HeaderGuest />
  }

  // Chọn header phù hợp dựa trên authentication status
  return isAuthenticated ? <HeaderAuthenticated /> : <HeaderGuest />
}
